"use strict";

(function (Drupal) {
  Drupal.behaviors.ctaTile = {
    attach: function attach(context, settings) {
      var ctaTile = document.querySelectorAll('.block-cta-tile');
      if (!ctaTile.length || document.body.classList.contains('layout-builder--is-enabled')) {
        return;
      }

      // suppress tooltip
      ctaTile.forEach(function (tile) {
        var link = tile.querySelector('a:not(.btn, .btn--ghost, .link-button)');
        if (link) {
          link.removeAttribute('title');
        }
      });
    }
  };
})(Drupal);